import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { useEffect, useState } from "react";
import Logo from '../Logo/Logo';
import Navigation from '../Navigation/Navigation';
import './style.scss';
import { Container } from '../Container/Container';

const Header = ({ pathname }) => {
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const [scrolled, setScrolled] = useState(false);
  
  
  useEffect(() => {

    const handleScroll = () => {
      setScrolled(window.scrollY > 60); // Adjust this threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    
    <div className={`header-wrapper ${scrolled ? "header--scrolled" : ""}`} role="banner">
      <Container>
        <div className={`header`}>
          <div className="logo-nav-wrapper">
            <div className="logo">
              <Logo />
            </div>
            <Navigation pathname={pathname} hideMobile={false}/>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
